import { createSlice } from '@reduxjs/toolkit';

const initialDeviceOSState = { type: 'all_versions', selectedOsVersions: [] };

const targetingDeviceOSSlice = createSlice({
  name: 'targetingDeviceOS',
  initialState: initialDeviceOSState,
  reducers: {
    changeDeviceOSTargetingType: (state, action) => {
      state.type = action.payload;
    },
  },
});

export const targetingDeviceOSActions = targetingDeviceOSSlice.actions;
export default targetingDeviceOSSlice.reducer;
